import styled from "@emotion/styled";
import { Carousel, Col, Image, Row } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RightArrows } from "../../common/component/RightArrows";
import { NewsItem } from "../../module/news/component/NewsItem";
import { NewsEntity } from "../../module/news/entity/news.entity";
import newsService from "../../module/news/service/news.service";

export const Home: FC = () => {
	const [width, setWidth] = useState<number>(1600);
	const [height, setHeight] = useState<number>(500);
	const [basicHeight, setBasicHeight] = useState('500px');
	const [imageStyle, setImageStyle] = useState({
		marginLeft: '0px',
		marginBottom: '0',
		marginRight: '0',
		marginTop: '0'
	});
	const [newsArr, setNewsArr] = useState<NewsEntity[]>([]);

	const navigate = useNavigate();

	const setRem = useCallback(() => {
		const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;

		let newWidth = 0;
		let newHeight = htmlWidth/1600*500;
		const basicHeight = htmlWidth < 500 ? 180 : (htmlWidth > 1600 ? 500 : 400);
		setBasicHeight(`${basicHeight}px`);
		if (htmlWidth < 1600) {
			newWidth = basicHeight/500*1600;
			newWidth = newWidth > htmlWidth ? newWidth : htmlWidth;
			newHeight = newWidth/1600*500;
			if (newHeight < basicHeight){
				newWidth = basicHeight/newHeight* newWidth;
				newHeight = basicHeight;
			}

			setImageStyle({
				marginTop: `${(basicHeight-newHeight)/2}px`,
				marginRight: '0',
				marginBottom: '0',
				marginLeft: `${(htmlWidth-newWidth)/2}px`
			});
			setWidth(newWidth);
			setHeight(newHeight);
		}
		if (htmlWidth >= 1600) {
			setWidth(htmlWidth);
			setHeight(newHeight);
			setImageStyle({
				marginTop: `${(500-newHeight)/2}px`,
				marginRight: '0',
				marginBottom: '0',
				marginLeft: '0'
			});
		}

		/**
		 * 图片宽度固定 1600*500
		 * 屏幕宽度小于1600，直接截宽度尺寸
		 * 屏幕宽度大于1600，等比放大宽度并截高度
		 */
	}, []);

	useEffect(() => {
		setRem();
	}, [setRem]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	const newsList = useCallback(async () => {
		const { data } = await newsService.list({ pageSize: 5 });
		setNewsArr(data.data);
	}, []);

	useEffect(() => {
		newsList();
	}, [newsList]);

	window.onresize = () => {
		setRem();
	};

	return (
		<Container>
			<div className='carouselArea' style={{height: basicHeight, overflow: 'hidden'}}>
				<Carousel autoplay>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/1.jpeg"} />
					</div>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/2.jpeg"} />
					</div>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/3.jpeg"} />
					</div>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/4.jpeg"} />
					</div>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/5.jpg"} />
					</div>
					<div className='carousel'>
						<Image preview={false} width={width} height={height} style={imageStyle} src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/sliders/6.jpeg"} />
					</div>
				</Carousel>
			</div>
			<div className='content'>
				<div className='col-md-12 col-xs-12'>
					<h2>欧皮特产品用于对耐用性和高质量要求的场景</h2>
				</div>
				<Row className='industry-product'>
					<Col xs={24} md={12} lg={12} style={{ padding: ".5rem", cursor: "pointer" }} onClick={() => navigate("/industries")}>
						<Image width='100%' preview={false} src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-home-strassenbau.jpg' />
						<div className='title'>
							<div className='button'>
								<div>行业相关</div>
								<div style={{ marginTop: "10px" }}>
									<RightArrows color='#FFF' />
								</div>
							</div>
						</div>
					</Col>
					<Col xs={24} md={12} lg={12} style={{ padding: ".5rem", cursor: "pointer" }} onClick={() => navigate("/products")}>
						<Image width='100%' preview={false} src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-home-produkte.jpg' />
						<div className='title'>
							<div className='button'>
								<div>产品相关</div>
								<div style={{ marginTop: "10px" }}>
									<RightArrows color='#FFF' />
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<div className='col-md-12 col-xs-12'>
					<h2>新闻中心</h2>
					<div className='news-list'>
						{newsArr &&
							newsArr.map((item, index) => {
								return <NewsItem value={item} key={index} />;
							})}
					</div>
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.carouselArea {
		border-bottom: 4px solid #dd271d;
	}

	.carousel {
		overflow: hidden;
	}

	.content {
		margin: 0 auto;
		.industry-product {
			margin-bottom: 48px;

			.col-md-6,
			.col-lg-6,
			.col-xs-12 {
				padding: 0;
			}

			.title {
				width: 100%;
				height: 111px;
				background-color: #004885;
				padding: 15px;
				cursor: pointer;

				.button {
					border: 1px solid #fff;
					color: #fff;
					height: 71px;
					line-height: 41px;
					padding: 15px;

					display: flex;
					justify-content: space-between;
				}
			}
		}
	}
`;
